import React, { useState, useContext } from "react";
import { Form, Button, Card, Row, Col } from '@themesberg/react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from '../../../../config/axios';
import { simpleAlert } from "../../../alerts/Alerts";
import { Context } from "../../../../context/Context";
import Swal from 'sweetalert2';

export const CreatePriceListForm = () => {
  const navigate = useNavigate();
  const [auth] = useContext(Context);

  const [formData, setFormData] = useState({
    name: '',
    description: '',
    default: false,
    check_percentage: false,
    percentage: 0,
    check_base_price: false,
    base_price: 0
  });

  const handleChange = ({ target: { name, value, type, checked } }) => {
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    Swal.fire({
      title: 'Creando lista de precios...',
      text: 'Por favor espera un momento.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      await axios.post(`/pricelist/create/user/${auth.id}`, formData);
      Swal.close();
      simpleAlert('Éxito', 'Lista de precios creada correctamente', 'success');
      navigate('/dashboard/pricelist');
    } catch (error) {
      Swal.close();
      console.error(error);
      simpleAlert('Error', 'No se pudo crear la lista de precios', 'danger');
    }
  };

  return (
    <Card border="light" className="bg-white shadow-sm mb-4">
      <Card.Body>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6} className="mb-3">
              <Form.Group controlId="name">
                <Form.Label>Nombre <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Nombre de la lista"
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={12} className="mb-3">
              <Form.Group controlId="description">
                <Form.Label>Descripción</Form.Label>
                <Form.Control
                  as="textarea"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Descripción de la lista"
                  rows={3}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6} className="mb-3">
              <Form.Group controlId="check_percentage">
                <Form.Label>¿Aplicar porcentaje de descuento?</Form.Label>
                <Form.Check
                  type="checkbox"
                  name="check_percentage"
                  label="Activar porcentaje automático"
                  checked={formData.check_percentage}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            {formData.check_percentage && (
              <Col md={6} className="mb-3">
                <Form.Group controlId="percentage">
                  <Form.Label>Porcentaje (%)</Form.Label>
                  <Form.Control
                    type="number"
                    name="percentage"
                    value={formData.percentage}
                    onChange={handleChange}
                    min="0"
                    max="100"
                  />
                </Form.Group>
              </Col>
            )}
          </Row>

          <Row>
            <Col md={6} className="mb-3">
              <Form.Group controlId="check_base_price">
                <Form.Label>¿Aplicar precio base?</Form.Label>
                <Form.Check
                  type="checkbox"
                  name="check_base_price"
                  label="Activar precio base fijo"
                  checked={formData.check_base_price}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            {formData.check_base_price && (
              <Col md={6} className="mb-3">
                <Form.Group controlId="base_price">
                  <Form.Label>Valor base ($)</Form.Label>
                  <Form.Control
                    type="number"
                    name="base_price"
                    value={formData.base_price}
                    onChange={handleChange}
                    min="0"
                  />
                </Form.Group>
              </Col>
            )}
          </Row>

          <div className="mt-3">
            <Button variant="primary" type="submit" className="w-100">
              Crear Lista de Precios
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};
